import { parseSafeInt } from "Backend";
import { LoaderFunctionArgs, ShouldRevalidateFunction, defer, redirect } from "react-router-dom";
import { fetchForm } from "redux/slices/form.slice";
import {
  fetchFieldAiConfigs,
  fetchFieldTagConfigs,
  fetchLensAndRules,
  fetchPageLabels,
  fetchReviewConfigs,
  fetchTags,
} from "redux/slices/lensEditor";
import store from "redux/store";

export const lensEditorLoader = async (args: LoaderFunctionArgs) => {
  const lensId = parseSafeInt(args.params.lensId);

  if (lensId === undefined) {
    return redirect("..");
  }

  return defer({
    load: Promise.all([
      store.dispatch(fetchFieldAiConfigs({ lensId })).unwrap(),
      store.dispatch(fetchFieldTagConfigs({ lensId })).unwrap(),
      store.dispatch(fetchLensAndRules({ lensId })).unwrap(),
      store.dispatch(fetchForm({ lensId })).unwrap(),
      store.dispatch(fetchReviewConfigs()).unwrap(),
      store.dispatch(fetchPageLabels({ lensId })).unwrap(),
      store.dispatch(fetchTags({ lensId })).unwrap(),
    ]),
  });
};

export const shouldRevalidateLensEditor: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.lensId !== nextParams.lensId;
};
